<mat-card class="cardT">Veículo</mat-card>
<div class="content">
    <form [formGroup]="editFormGroup" class="content-body">

        <div class="input-group col-1">
            <mat-form-field appearance="outline">
                <mat-label>Marca</mat-label>
                <input type="text" matInput formControlName="dsMarca" maxlength="20" />
                <app-field-error matSuffix [control]="editFormGroup.get('dsMarca')"></app-field-error>
            </mat-form-field>
        </div>

        <div class="input-group col-3">
            <mat-form-field appearance="outline">
                <mat-label>Modelo</mat-label>
                <input type="text" matInput formControlName="dsModelo" maxlength="20" />
                <app-field-error matSuffix [control]="editFormGroup.get('dsModelo')"></app-field-error>
            </mat-form-field>
        </div>

        <div class="input-group col-1">
            <mat-form-field appearance="outline">
                <mat-label>Ano Fabricação</mat-label>
                <input type="number" matInput formControlName="dsAnoFabricacao" max="9999" min="0"
                    oninput="if(this.value.length > 4) this.value=this.value.slice(0,4)" />
                <app-field-error matSuffix [control]="editFormGroup.get('dsAnoFabricacao')"></app-field-error>
            </mat-form-field>
        </div>
        <div class="input-group col-3">
            <mat-form-field appearance="outline">
                <mat-label>Ano Modelo</mat-label>
                <input type="number" matInput formControlName="dsAnoModelo" max="9999" min="0"
                    oninput="if(this.value.length > 4) this.value=this.value.slice(0,4)" />
                <app-field-error matSuffix [control]="editFormGroup.get('dsAnoModelo')"></app-field-error>
            </mat-form-field>
        </div>

        <div class="input-group col-1">
            <mat-form-field appearance="outline">
                <mat-label>Cor</mat-label>
                <input type="text" matInput formControlName="dsCor" maxlength="20" />
                <app-field-error matSuffix [control]="editFormGroup.get('dsCor')"></app-field-error>
            </mat-form-field>
        </div>

        <div class="input-group col-3">
            <mat-form-field appearance="outline">
                <mat-label>Placa</mat-label>
                <input type="text" matInput formControlName="dsPlaca" maxlength="7"
                    pattern="^[A-Za-z]{3}[0-9]{1}[A-Za-z0-9]{1}[0-9]{2}$" />
                <app-field-error matSuffix [control]="editFormGroup.get('dsPlaca')"
                    [formatExample]="'Formato: AAA1A11 ou AAA1111'"></app-field-error>
            </mat-form-field>
        </div>

        <div class="buttons col-1">
            <button type="submit" color="primary" class="btn" mat-raised-button [disabled]="editFormGroup.invalid"
                (click)="onSalvar()"> Salvar </button>
            <button type="button" color="basic" class="btn" mat-raised-button routerLink="/veiculos">
                Voltar </button>
        </div>
    </form>
</div>

<mat-card class="cardT">Dados do Veículo</mat-card>
<div class="veiculo-dados-div">
    <app-veiculo-x-usuarios *ngIf="veiculo" [veiculo]="veiculo"></app-veiculo-x-usuarios>
    <app-list-veiculo-abastecimentos *ngIf="veiculo" [veiculo]="veiculo"></app-list-veiculo-abastecimentos>
</div>

<div class="subscription" *ngIf="subscription">
    <div>
        <mat-spinner></mat-spinner>
        <p>Carregando...</p>
    </div>
</div>